import { useUser } from '@/pb'
import LogoutIcon from '@mui/icons-material/Logout'
import { Button, Paper, Typography } from '@mui/material'
import { useMemo } from 'react'

const stringify = value => typeof value === 'string' ? value : JSON.stringify(value)

const columns = [
  { field: 'key', headerName: 'Параметр', width: 300 },
  { field: 'value', headerName: 'Значение', width: 300 },
]

export default function Account() {

  const { user, logout } = useUser()
  const rows = useMemo(() => Object.entries(user).map(([key, value]) => ({ id: key, key, value: String(value) })), [user])

  return <>
    <Paper className="content">
      <Button
        style={{ float: 'right' }}
        variant="outlined"
        color="error"
        endIcon={<LogoutIcon />}
        onClick={logout}
      >
        Выйти
      </Button>
      <Typography variant="h5">
        {user.name || 'Без имени'}
      </Typography>
      <Typography>
        <code>{user.email}</code>
        <br/><code>{user.phone}</code>
      </Typography>

      {/* <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
        >
          <Typography component="span">Данные пользователя</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <DataGrid
            disableRowSelectionOnClick
            rows={rows}
            columns={columns}
          />
        </AccordionDetails>
      </Accordion> */}

    </Paper>
  </>
}